import axios from 'utils/axios';


export function bytesToBase64(bytes) {
    let binary = '';
    const byteArray = new Uint8Array(bytes);
  
    byteArray.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });
  
    return btoa(binary);
  }

  export const formatDate = (date) => {

    if (!date) return '—';
    
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
  
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  export const formatDateTime = (date) => {
    if (!date) return '—';

    const parsed = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(parsed.getTime())) return '—';

    const day = parsed.getDate().toString().padStart(2, '0'); // Ensure two digits
    const month = (parsed.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
    const year = parsed.getFullYear();
    const hour = parsed.getHours().toString().padStart(2, '0'); // 24-hour format
    const minute = parsed.getMinutes().toString().padStart(2, '0');
    const second = parsed.getSeconds().toString().padStart(2, '0');
  
    return `${day}.${month}.${year} ${hour}:${minute}:${second}`; // Format: dd.mm.yyyy hh:mm:ss
  };

  export async function handleDownload(id, fileName) {
    try {
      const response = await axios.get('upload/' + id, {
        responseType: 'arraybuffer', // Important for binary data
      });
  
      console.log(response, response.headers['content-type']);
  
      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const url = URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  }
